<template>
  <card class="task-options__card">
    <template #header>
      <div class="card-text">
        <div class="card-text__title">
          <h4 class="card-title">
            {{ title }}
          </h4>
          <img :src="`/static/img/flags/128/${icon}.png`" alt="">
        </div>
        <p class="card-category">
          Для редактирования кликните по значению
        </p>
      </div>
    </template>
    <el-table v-if="!!list.length" :data="list">
      <el-table-column align="left" prop="title"/>
      <el-table-column align="right" label="min" width="105px">
        <template #default="scope">
          <div
            v-if="editedValueId !== scope.row.minId"
            @click="() => {editedValueId = scope.row.minId}">
            {{ scope.row.minValue }}
          </div>
          <div v-else>
            <fg-input
              :ref="`input-${scope.row.minId}`"
              v-model="scope.row.minValue"
              type="text"
              class="task-options__edit-in-place payout-cell"
              transform-method="onlyDigits"
              @created="handleInputCreated"
              @blur="handleInputBlur"
              @input="(e) => handleInputChange(e, scope.row.minId)"
              @pressEnter="handleInputBlur"/>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="right" label="max" width="105px">
        <template #default="scope">
          <div
            v-if="editedValueId !== scope.row.maxId"
            @click="() => {editedValueId = scope.row.maxId}">
            {{ scope.row.maxValue }}
          </div>
          <div v-else>
            <fg-input
              :ref="`input-${scope.row.maxId}`"
              v-model="scope.row.maxValue"
              type="text"
              class="task-options__edit-in-place payout-cell"
              transform-method="onlyDigits"
              @created="handleInputCreated"
              @blur="handleInputBlur"
              @input="(e) => handleInputChange(e, scope.row.maxId)"
              @pressEnter="handleInputBlur"/>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <template #footer>
      <div v-if="loading || download" class="task-options__dummy">
        <indicator/>
      </div>
      <div v-else class="task-options__toolbar">
        <p-button :disabled="btnDisabled" @click="updateData">
          Применить
        </p-button>
      </div>
    </template>
  </card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Indicator from '../../UIComponents/Custom/Indicator'

export default {
  name: 'PayoutLimitsCard',
  components: {
    Indicator
  },
  props: {
    title: String,
    icon: String,
    list: Array,
    groupedLimits: Array,
    download: Boolean
  },
  data() {
    return {
      loading: false,
      editedValueId: null,
      disable: false,
      touchedValueId: undefined,
      changedData: {}
    }
  },
  computed: {
    ...mapGetters({
      payoutLimits: 'superadministrator/payoutLimits'
    }),
    btnDisabled() {
      return !Object.keys(this.changedData).length
    }
  },
  watch: {
    editedValueId(value) {
      if (!value || this.touchedValueId === value) return
      this.touchedValueId = value
    },
  },
  methods: {
    ...mapActions({
      editPayoutLimits: 'superadministrator/editPayoutLimits'
    }),
    async updateData() {
      this.loading = true
      try {
        await this.editPayoutLimits(this.changedData)
        this.touchedValueId = undefined
        this.changedData = {}
      } finally {
        this.loading = false
      }
    },
    handleInputCreated() {
      const value = this.editedValueId
      if (!value) return
      this.$refs[`input-${value}`].onFocus()
    },
    handleInputBlur() {
      this.editedValueId = null
    },
    handleInputChange(e, id) {
      if (!id && this.touchedValueId === id) return
      this.touchedValueId = id
      this.changeValue(e.target.value, id)
    },
    changeValue(actValue, id) {
      const limit = this.payoutLimits.find(item => item.id === id)
      const groupName = limit.name.slice(0, -4)
      const limitDirection = limit.name.slice(-3)
      const group = this.groupedLimits.find(item => item.name === groupName)
      if (!group) return
      if (!actValue) this.list.find(item => item.name === groupName)[limitDirection + 'Value'] = 0
      if (parseInt(actValue) === parseInt(limit.value)) return
      this.changedData[id] = actValue ?? 0
      this.touchedValueId = undefined
    }
  }
}
</script>

<style scoped>

</style>
